import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _cache[0] || (_cache[0] = [
    _createElementVNode("h2", { class: "text-center" }, [
      _createElementVNode("a", {
        href: "#top",
        class: "text-decoration-none"
      }, " ☝️ Scroll to top ")
    ], -1)
  ])))
}